import axios from "axios";
import { AuthGateApiClient, RefreshTokenRequest } from "./ApiServerHooks";

export class SingletonRefreshClient {
    public static isRefreshing: boolean;
    private constructor() {
    }
    public static setRefresh() {
        this.isRefreshing = true;
    }
    public static completeRefresh() {
        this.isRefreshing = false;
    }
    public static async refreshToken(): Promise<void> {

        // The session this refresh is based on. A login finishing in parallel can replace it
        // while the request is in flight - the outcome of this refresh is then stale and must
        // neither overwrite the newer tokens nor be reported as a failed session.
        const refreshedFrom = localStorage.getItem('token');
        let tokens;
        try {
            tokens = (await this.GetClientToAuth().refreshToken(new RefreshTokenRequest({
                accessToken: refreshedFrom!,
                refreshToken: localStorage.getItem('refresh_token')!
            })));
        }
        catch (e) {
            if (localStorage.getItem('token') !== refreshedFrom) return;
            throw e;
        }
        if (tokens.accessToken === undefined) throw new Error('token is undefined');
        if (localStorage.getItem('token') !== refreshedFrom) return;
        localStorage.setItem('token', tokens.accessToken);
        localStorage.setItem('token_expires', tokens.expireAt?.toString()!);
        localStorage.setItem('refresh_token', tokens.refreshToken!);

    }
    private static GetClientToAuth(): AuthGateApiClient {
        const axiosApiInstance = axios.create();

        // Request interceptor for API calls
        axiosApiInstance.interceptors.request.use(
            async config => {
                // let culture = localStorage.getItem('i18nextLng');
                // let culture = localStorage.getItem('i18nextLng');
                config.headers['TimeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // config.headers.set('accept-language', culture);
                config.headers.Accept = 'application/json';
                config.headers["Content-Type"] = 'application/json';

                return config;
            },
            error => {
                Promise.reject(error)
            });
        axiosApiInstance.interceptors.response.use((response) => {
            return response
        }, async function (error) {
            console.log('error', error);
           
            return Promise.reject(error);
        });
        return new AuthGateApiClient(this.GetApiAddress(), axiosApiInstance);
    }
    protected static GetApiAddress(): string {
        return process.env.REACT_APP_GATE_URL!;
    }

}